import React, { useEffect, useContext } from "react";
import { motion } from "framer-motion";
import ThemeToggle from "./ThemeToggle";
import { ThemeContext } from "../App";
import "../styles/global.css";

interface HeaderProps {
  setIsModalOpen?: (isOpen: boolean) => void;
}

function Header({ setIsModalOpen = () => {} }: HeaderProps) {
  const { theme } = useContext(ThemeContext);

  return (
    <motion.header 
      className="hero-header"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="container">
        <motion.h1
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.2, duration: 0.8 }}
        >
          My Abnormal Story
        </motion.h1>
        
        <motion.p 
          className="tagline"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.8 }}
        >
          Share your alternative cancer treatment journey and help others find
          hope
        </motion.p>

        <motion.button
          className="btn btn-primary cta-button"
          onClick={() => setIsModalOpen(true)}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.5 }}
          whileHover={{ 
            scale: 1.05,
            boxShadow: `0 6px 20px rgba(${theme === 'light' ? '59, 130, 246, 0.5' : '96, 165, 250, 0.5'})` 
          }}
          whileTap={{ scale: 0.98 }}
        >
          Share Your Story
        </motion.button>
      </div>
    
    </motion.header>
  );
}

export default Header;